import React from 'react';
import Point from '../Point/Point';
import RouteArrow from '../RouteArrow/RouteArrow';
import { getDurationString, getFlightDuration } from '../../../../Results/utils';
import StopsInfo from '../StopsInfo/StopsInfo';
import { useTheme } from '../../../../theme';
import {
	ScheduleResultSegmentWithTransferDuration,
	SegmentStopFragment,
	SegmentWithTransferFragment
} from '@websky/graphql';
import cn from 'classnames';
import { format, removeDotsFromDate } from '../../../../utils';

interface Props {
	segmentWithTransfer: SegmentWithTransferFragment | ScheduleResultSegmentWithTransferDuration;
	segments?: SegmentWithTransferFragment[];
	first?: boolean;
	last?: boolean;
	stops?: SegmentStopFragment[];
	multipleSegments?: boolean;
	stopsSeparator?: string;
	isCanceled?: boolean;
	isMobile?: boolean;
}

const RouteInfo: React.FC<Props> = ({
	segmentWithTransfer,
	segments,
	first,
	last,
	stops,
	isCanceled,
	stopsSeparator
}) => {
	const theme = useTheme('DesktopFlightRoute').RouteInfoStyles;
	const arrowTheme = useTheme('DesktopFlightRoute').RouteArrowStyles;
	const pointTheme = useTheme('DesktopFlightRoute').PointStyles;

	const { segment } = segmentWithTransfer;
	const { arrival, departure } = segment;
	const {
		arrival: { airport: arrivalAirport },
		departure: { airport: departureAirport }
	} = segment;

	const flightNumber = `${segment.marketingAirline.iata}-${segment.flightNumber}`;

	const stopsCount = stops?.length;
	const hasStops = !!stopsCount;

	const departureDate =
		'date' in departure && departure.date ? removeDotsFromDate(format(departure.date, 'dd MMM, EEEEEE')) : '';
	const arrivalDate =
		'date' in arrival && arrival.date ? removeDotsFromDate(format(arrival.date, 'dd MMM, EEEEEE')) : '';

	const timeInRoute =
		segments?.length > 1 ? getDurationString(getFlightDuration(segments)) : getDurationString(segment.duration);

	return (
		<div className={theme.route__info}>
			<div className={theme.row}>
				<Point time={segment.departure.time} thin={!first} date={departureDate} />

				<RouteArrow timeInRoute={timeInRoute} className={theme.arrow_container} />

				<Point time={segment.arrival.time} thin={!last} arrival={true} date={arrivalDate} />
			</div>

			<div className={theme.row}>
				<div className={pointTheme.airport}>
					{departureAirport.name} ({departureAirport.iata})
				</div>

				{flightNumber && <div className={arrowTheme.flightNumber}>{flightNumber}</div>}

				<div className={cn(pointTheme.airport, pointTheme.airport_arrival)}>
					{arrivalAirport.name} ({arrivalAirport.iata})
				</div>

				{hasStops && !isCanceled && (
					<StopsInfo stops={stops} stopCityName={arrivalAirport.name} separator={stopsSeparator} />
				)}
			</div>
		</div>
	);
};

export default RouteInfo;
